<template>
    <div>
        <v-layout row align-center justify-space-between class="header report-header">
            <v-btn flat dark :to="'/bot/' + activeBot.code">
                <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
                back
            </v-btn>
            <div style="font-size: 20px" class="report-title">{{$t('ticketManagement')|capitalize}}</div>
            <div>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout align-center v-on="on" style="cursor: pointer" class="report-bot-list">
                            <span>{{ activeBot ? activeBot.name : '' }}</span>
                            <v-icon color="#fff">mdi-chevron-down</v-icon>
                        </v-layout>
                    </template>
                    <div style="max-height: 352px; overflow: auto;">
                        <v-list>
                            <v-list-tile
                                    v-for="bot in botList"
                                    :key="bot.code"
                                    @click="changeBot(bot)"
                                    :class="activeBot.code === bot.code ? 'active' : ''"
                            >
                                <v-list-tile-title>{{bot.name}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-menu>
            </div>
        </v-layout>
        <v-container fluid grid-list-sm>
            <v-card class="pa-1">
                <v-layout class="d-none">
                    <v-flex xs4>
                        <v-select
                                v-model="supporter"
                                label="Supporter"
                                :items="supporterList"
                                disabled
                        />
                    </v-flex>
                    <v-flex xs4>
                        <v-select
                                v-model="channel"
                                label="Channel"
                                :items="channelList"
                                disabled
                        />
                    </v-flex>
                    <v-flex xs4>
                        <v-select
                                v-model="density"
                                label="Density"
                                :items="densityList"
                                disabled
                        />
                    </v-flex>
                    <v-spacer/>
                </v-layout>
                <v-layout class="report-filter" style="gap: 8px">
                    <v-flex xs3>
                      <v-text-field
                          v-model="keyword"
                          label="Search"
                          @change="getData"
                          placeholder="Sender name/Ticket title/Support request"
                      />
                    </v-flex>
                    <v-flex xs1>
                        <v-select
                                v-model="tktStatus"
                                label="Status"
                                @change="getData"
                                :items="tktStatusList"
                        />
                    </v-flex>
                    <v-flex xs1>
                        <v-select
                                v-model="interval"
                                label="Interval"
                                :items="intervalList"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <DatePicker
                                v-model="fromDate"
                                label="From Date"
                                :max="toDate"
                                :disabled="interval !== 'custom'"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <DatePicker
                                v-model="toDate"
                                label="To Date"
                                :min="fromDate"
                                :max="today"
                                :disabled="interval !== 'custom'"
                        />
                    </v-flex>
                    <v-btn color="primary" @click="getData" v-if="interval === 'custom'">Get Data</v-btn>
                    <v-btn color="primary" @click="exportExcel" :disabled="is_lock_report">Export Excel</v-btn>
                </v-layout>
            </v-card>
            <v-card class="my-3">
                <v-data-table
                        :items="dataTableSort"
                        :headers="headers"
                        :pagination.sync="pagination"
                        :total-items="total_reports"
                        :rows-per-page-items="rowsPerPageItems"
                >
                    <template v-slot:items="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td v-for="header of headers" :key="header.value" :width="header.width">
                                <span v-if="header.value!=='action'" class="break-word">
                                    <span v-if="header.$value">{{header.$value(props.item)}}</span>
                                    <span v-else v-html="props.item[header.value]" v-linkified></span>
                                </span>
                                <span v-else>
                                     <v-btn depressed round small color="success" v-if="props.item['status']==='0'" dark @click="closeTicket(props.item, props.item.index)">Close Ticket</v-btn>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
        <div class="chat_view_loading" v-if="loadingDialog">
            <div class="loading_overlay"></div>
            <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import ReportService from '@/services/report.service'
import _ from 'lodash'
import moment from 'moment'
import DatePicker from '@/components/custom/DatePicker'
import BotService from '@/services/bot.service'
import {mapState} from "vuex";
import ActionTypes from "@/store/ActionTypes";

export default {
        name: 'TicketManagement',
        components: {DatePicker},
        data() {
            return {
                tktStatus: '',
                fromDate: moment().subtract(6, 'day').format('YYYY-MM-DD'),
                toDate: moment().format('YYYY-MM-DD'),
                today: moment().format('YYYY-MM-DD'),
                // senderName: '',
                keyword: '',
                interval: '7days',
                density: 'daily',
                supporter: 'all',
                channel: 'all',
                activeBot: {},
                dataTable: [],
                total_reports: 0,
                is_lock_report: false,
                min: {},
                max: {},
                supporterList: [
                    {text: 'All', value: 'all'}
                ],
                channelList: [
                    {text: 'All', value: 'all'}
                ],
                densityList: [
                    {text: 'Daily', value: 'daily'},
                    {text: 'Weekly', value: 'weekly'},
                    {text: 'Monthly', value: 'monthly'}
                ],
                intervalList: [
                    {text: 'Last 7 days', value: '7days'},
                    {text: 'Last 30 days', value: '30days'},
                    {text: 'Custom', value: 'custom'}
                ],
                tktStatusList: [
                    {text: 'All', value: ''},
                    {text: 'Opening', value: '0'},
                    {text: 'Closed', value: '1'},
                ],
                pagination: {

                },
                rowsPerPageItems: [10, 20, 50, 100],
                loadingDialog: false,
                botList: [],
                headers: [
                    {
                        text: 'No',
                        value: 'index',
                        sortable: false,
                        width: '2%'
                    },
                    {
                        text: 'Sender Name',
                        value: 'sender_name',
                        sortable: false,
                        width: '10%'
                    },
                    {
                        text: 'Ticket Title',
                        value: 'title',
                        sortable: false,
                        width: '10%'
                    },
                    {
                        text: 'Support Request',
                        value: 'support_request',
                        sortable: false,
                        width: '30%'
                    },
                    {
                        text: 'Created At',
                        value: 'created_time',
                        $value: item => this.dateFormat(item.created_time),
                        sortable: false,
                        width: '8%'
                    },
                    {
                        text: 'Status',
                        value: 'status',
                        $value: item => item.status === '0' ? 'Opening' : 'Closed',
                        sortable: false,
                        width: '5%'
                    },
                    {
                       text: 'Closed By/Closed Time',
                       value: 'closed_by',
                        $value: item => item.status === '1' ? `${item.closed_by.email} / ${this.dateFormat(item.updated_time)}` : '',
                        sortable: false,
                        width: '10%'
                    },
                    {
                        text: 'Action',
                        value: 'action',
                        sortable: false,
                        width: '5%'
                    }
                ],
            }
        },
        computed: {
            ...mapState(['notifyBotChat']),
            dataTableSort() {
                let clone = []
                if (this.dataTable.length) {
                    clone = [...this.dataTable]
                    clone = clone.map((items, index) => ({...items, index: index + 1}))
                } else {
                    return []
                }
                if (this.pagination.sortBy) {
                    let header = _.find(this.headers, item => item.value === this.pagination.sortBy)
                    return _.orderBy(
                        clone,
                        item => header.$value ? header.$value(item) : item[header.value],
                        this.pagination.descending ? 'desc' : 'asc'
                    )
                }
                return clone
            },
        },
        mounted() {
            this.loadingDialog = true
            BotService.getAllBot().then(
                result => {
                    this.botList = result.data;
                    let botCode = this.$route.params.botCode
                    if (botCode) {
                        let bot = _.find(this.botList, bot => bot.code === botCode)
                        if (bot) {
                            this.selectBot(bot)
                        } else {
                            this.loadingDialog = false
                            this.$router.push('/session-info')
                        }
                    } else if (this.botList.length > 0) {
                        this.selectBot(this.botList[0])
                    } else {
                        this.loadingDialog = false
                    }
                },
            ).catch(()=>{
                this.$AppService.handleRequestError('can not get bot list')
            });
        },
        methods: {
            async getData() {
                this.loadingDialog = false
                if (this.activeBot.code) {
                    await ReportService.TicketReportStatus(this.activeBot.code)
                        .then((res)=> {
                            this.is_lock_report = res.data['is_lock']
                        })
                        .catch(e=>{
                            this.$AppService.handleRequestError('Get lock report status failed')
                        });
                    ReportService.Ticket(this.activeBot.code, this.tktStatus, this.keyword,this.toISOString(this.fromDate, true), this.toISOString(this.toDate), this.pagination.page, this.pagination.rowsPerPage)
                        .then(result => {
                            this.dataTable = result['data']['results'];
                            this.loadingDialog = false;
                            this.total_reports = result.data.count;
                        }, ()=> {
                            this.$AppService.handleRequestError('Can not get ticket data')
                            this.loadingDialog = false
                        })
                }
            },
            async exportExcel() {
                ReportService.TicketReportExcel(this.activeBot.code, this.tktStatus, this.keyword,this.toISOString(this.fromDate, true), this.toISOString(this.toDate))
                    .then(() => {
                        this.$AppService.toastSuccess("The report information version is being processed, you will receive report notification via email after a few minutes.");
                        this.is_lock_report = true
                    }).catch(()=> {
                    this.$AppService.toastError("Ticket Report Failed");
                });
            },
            toISOString(date, startOfDay) {
                return startOfDay ? moment(date).startOf('day').toISOString() : moment(date).endOf('day').toISOString()
            },
            dateFormat(date) {
                return moment(date).format('DD-MM-YYYY HH:mm')
            },
            changeBot(bot) {
                this.$store.commit(ActionTypes.BOT, bot)
                this.$router.push('/ticket-management/' + bot.code)
            },
            selectBot(bot) {
                this.activeBot = bot;
                this.getData()
            },
            changeSort(headerValue) {
                let pagination = {...this.pagination}
                if (pagination.sortBy === headerValue) {
                    pagination.descending = !this.pagination.descending
                } else {
                    pagination.sortBy = headerValue
                    pagination.descending = true
                }
                this.pagination = pagination
                setTimeout(() => {
                    this.$forceUpdate()
                }, 2000)
            },
            closeTicket(ticket, idx) {
                let tktId = ticket._id;
                BotService.closeTicket(this.activeBot.code, tktId)
                    .then(resp => {
                            let newTkt = resp.data;
                            this.$set(this.dataTable, idx - 1, newTkt);
                            this.$AppService.toastSuccess("Ticket is closed");
                        },
                    ).catch(()=> {this.$AppService.toastError("Close ticket failed")})
            }
        },
        watch: {
            interval(val) {
                let get_statistic = false
                switch (val) {
                    case '7days' :
                        this.fromDate = moment().subtract(6, 'day').format('YYYY-MM-DD')
                        this.toDate = this.today
                        get_statistic = true
                        break
                    case '30days':
                        this.fromDate = moment().subtract(29, 'day').format('YYYY-MM-DD')
                        this.toDate = this.today
                        get_statistic = true
                        break
                    default:
                        break
                }
                if (get_statistic) {
                    this.getData()
                }

            },
            pagination: {
                handler() {
                    this.getData()
                }
            },
            '$route'() {
                let botCode = this.$route.params.botCode
                if (botCode) {
                    let bot = _.find(this.botList, bot => bot.code === botCode)
                    if (bot) {
                        this.selectBot(bot)
                    }
                }
            },
            notifyBotChat(val) {
                if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.TICKET_REPORT_STATUS) {
                    if (val.data.is_success) {
                        this.$AppService.toastSuccess("Excels report success. Please check email")
                    }
                    else {
                        this.$AppService.handleRequestError("Excels report failed. Please contact administrator")
                    }
                    this.is_lock_report = false
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .header {
        background: #2a4e69;
        color: #fff;
        padding: 0 15px;
    }
    .break-word {
        white-space: break-spaces;
        overflow-wrap: break-word;
        word-break: break-word;
    }
    td { white-space:pre }
    ::v-deep table.v-table {
        thead th {
            padding: 12px 0 12px 12px;
        }

        tbody tr td {
            white-space: nowrap;
            padding: 12px 0 12px 12px;
        }
    }
    ::v-deep .v-btn__content {
        text-transform: none;
    }
    ::v-deep .v-btn--small {
        font-size: 13px !important;
    }
    .header-tooltips {
        width: 240px;
        background: #1b3447;
        color: #fff;
        padding: 5px;

        &::v-deep hr {
            border-color: #2a4b64;
        }
    }
    ::v-deep .status-closed {
        cursor: none;
    }
    .info-icon {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);;
        caret-color: rgb(73, 119, 238);
    }

    .tooltips-info {
        div:first-child {
            color: #00afc8;
        }
    }

    ::v-deep .v-list .active {
        background: #ccc;
    }

    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 27%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }
</style>
